// Contact override config for Gaaya 39 branch
export const gaayaOverride = {
  contacts: [
    {
      id: 'whatsapp',
      type: 'whatsapp' as const,
      href: 'https://wa.me/6622622133?contact-widget',
      title: 'WhatsApp',
      icon: 'whatsapp',
      bgColor: 'bg-[#25D366]',
      hoverColor: 'hover:bg-[#1da851]'
    },
    {
      id: 'messenger',
      type: 'messenger' as const,
      href: 'https://m.me/gaayaspabyoasis?contact-widget',
      title: 'Facebook Messenger',
      icon: 'messenger',
      bgColor: 'bg-[#1877F2]',
      hoverColor: 'hover:bg-[#1464d8]'
    },
    {
      id: 'line',
      type: 'line' as const,
      href: 'https://lin.ee/IpgCrqF?contact-widget',
      title: 'Line',
      icon: 'line',
      bgColor: 'bg-[#06C755]',
      hoverColor: 'hover:bg-[#05b04a]'
    },
    {
      id: 'instagram',
      type: 'instagram' as const,
      href: 'https://www.instagram.com/gaayabyoasis?contact-widget',
      title: 'Instagram',
      icon: 'instagram',
      bgColor:
        'bg-[radial-gradient(circle_at_30%_107%,#fdf497_0%,#fdf497_5%,#fd5949_45%,#d6249f_60%,#285AEB_90%)]',
      hoverColor: 'hover:opacity-90'
    }
  ],
  phone: {
    city: 'Menu.CITY_BKK',
    phone: '+6622622122',
    displayPhone: '+66 22 622 122'
  },
}
